"use client"
import { useVisualizer, VisualizerProvider } from "@/lib/visualizer-context"
import { FormPreview } from "@/components/form-preview"
import { Button } from "@/components/ui/button"
import { useState, useEffect } from "react"
import { Link, usePage } from "@inertiajs/react"
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet"
import { Menu } from "lucide-react"
import { PDFViewer } from "@/components/PdfViewer"
import { createRefreshChannel } from "@/channels/refresh_channel"
import { getCSRFToken } from "@/lib/utils"





function DataEditorPage() {
	const { config, pdf_id } = usePage().props
	const { data, setData, visualizerConfig, dataSchema } = useVisualizer()
	const [localData, setLocalData] = useState(data)
	const [dataChanged, setDataChanged] = useState(false)
	const [showPDF, setShowPDF] = useState(false)
	console.log("data: ", data)
	console.log("config", visualizerConfig)

	useEffect(() => {

		const isEqual = JSON.stringify(localData) === JSON.stringify(data)
		setDataChanged(!isEqual)

	}, [localData])


	useEffect(() => {
		createRefreshChannel(['users'])
	}, [])


	const handleSave = () => {
		const csrfToken = getCSRFToken()
		fetch(`/pdf_extraction/${pdf_id}`, {
			method: "PUT",
			headers: {
				"Content-Type": "application/json",
				"X-CSRF-Token": csrfToken || "",
			},
			body: JSON.stringify({ id: pdf_id, final_result: localData })
		})

	}

	const handleReset = () => {
		setLocalData(data)
	}

	const capitalize = (s: string) => {
		if (typeof s !== "string") return ""
		if (s.length === 0) return s
		return s.charAt(0).toUpperCase() + s.slice(1)
	}

	return (
		<div className="h-screen flex flex-col bg-background">
			<div className="border-b border-border bg-muted/30 px-4 py-4">
				<div className="flex items-center justify-between max-w-7xl mx-auto">

					{/* LEFT SIDE – TITLE */}
					<Link href="/">
						<div>
							<h1 className="text-2xl md:text-3xl font-bold">
								{capitalize(config?.name)}
							</h1>

						</div>
					</Link>


					{/* DESKTOP BUTTONS */}
					<div className="hidden md:flex gap-2">

						<Button variant="outline" onClick={handleReset}>
							Reset Changes
						</Button>
						<Button
							variant={dataChanged ? "destructive" : "ghost"}
							disabled={!dataChanged}
							onClick={handleSave}
						>
							Save Data
						</Button>
						<Button className="mr-4" variant="secondary" onClick={() => setShowPDF(true)}>
							View PDF
						</Button>
					</div>

					{/* MOBILE ACTION MENU */}
					<div className="md:hidden">
						<Button className="mr-4" variant="secondary" onClick={() => setShowPDF(true)}>
							View PDF
						</Button>
						<Sheet>
							<SheetTrigger asChild>
								<Button variant="outline" size="icon">
									<Menu className="h-5 w-5" />
								</Button>
							</SheetTrigger>
							<SheetContent side="right">
								<SheetHeader>
									<SheetTitle>Actions</SheetTitle>
								</SheetHeader>

								<div className="flex flex-col mt-6 gap-3">

									<Button variant="outline" onClick={handleReset}>
										Reset Changes
									</Button>
									<Button
										variant={dataChanged ? "destructive" : "ghost"}
										disabled={!dataChanged}
										onClick={handleSave}
									>
										Save Data
									</Button>
								</div>
							</SheetContent>
						</Sheet>
					</div>
				</div>
			</div>

			<div className="flex-1 overflow-auto">
				<FormPreview
					config={visualizerConfig}
					dataSchema={dataSchema}
					data={localData}
					editable={true}
					onDataChange={setLocalData}
				/>
			</div>
			<Sheet open={showPDF} onOpenChange={setShowPDF}>
				<SheetContent side="right" className="w-full lg:w-[60vw] h-screen sm:w-screen sm:max-w-none p-0 flex flex-col">
					<SheetHeader className="border-b px-4 py-3">
						<SheetTitle>PDF Viewer</SheetTitle>
					</SheetHeader>
					<div className="flex-1 overflow-hidden">
						<PDFViewer pdfUrl={`${pdf_id}`} fileName={`record.pdf`} />
					</div>
				</SheetContent>
			</Sheet>
		</div >
	)
}

DataEditorPage.layout = (page: any) => {
	return (
		<VisualizerProvider config={page?.props.config} data={page?.props.data} >
			{page}
		</VisualizerProvider>
	)
}
export default DataEditorPage
